module.exports = __webpack_public_path__ + "img/3.44c7909d.jpg";